
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeAnalytics, trackGTMEvent } from './utils/analytics'

// Initialize analytics as soon as possible, but with all storage denied by default
initializeAnalytics();

// Ensure critical GTM events are fired for consent initialization
trackGTMEvent('gtm.init_consent', { uniqueEventId: 6 });

// Additional explicit consent signals for GTM
if (window.dataLayer) {
  // Signal GTM consent initialization with specific flags - all denied by default
  window.dataLayer.push({
    'event': 'consent_initialization',
    'consent_flags': {
      'behavioral_analytics': 'denied',
      'ad_settings': 'denied',
      'requires_active_input': true,
      'consent_version': '2.0'
    }
  });
  
  // Add explicit consent mode initialization signal
  window.dataLayer.push({
    'event': 'consent_mode_initialization',
    'consent_mode_enabled': true,
    'default_consent': 'denied'
  });
}

createRoot(document.getElementById("root")!).render(<App />);

